const env = {
    url: 'wss://queue.gimme.network:15674/ws',
    server: 'prod',
    module: 5,
};

export default env;
